/* Structural layout only — colors come from Astryx design tokens (resolved
   inside a <Theme> scope). */

.label {
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
